/**
 * Whether the dermatoscope is powered on or off.
 */
export enum DermatoscopePowerStatus {
  PoweredOn = 'powered-on',
  PoweredOff = 'powered-off',
}
